import React from 'react';
import { SECTION_TYPE } from '../../constants';
import { formatText } from 'core/i18n';
import { doTagSendRecoverTag } from '../../tagging';
import { isMobile } from 'utilities/browser';
import { PUBLICA_URL, LOGIN_DESKTOP, LOGIN_MOBILE } from 'constants/index';

const { PERSONAL_DATA, PRECONTRACTUAL_DOCS, EMAIL_OTP_VALIDATION, ACCESS_DATA } = SECTION_TYPE;
export const createSubtitle = type => {
    if (type === PERSONAL_DATA) {
        return (
            <>
                {formatText('initial-continueProcess')}
                <a onClick={doTagSendRecoverTag} href={`${PUBLICA_URL}${isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP}`}>
                    {formatText('initial-link')}
                </a>
            </>
        );
    }
    if (type === PRECONTRACTUAL_DOCS) return formatText('precontractualDocSection-readFollowingDocuments');
    if (type === EMAIL_OTP_VALIDATION) return formatText('emailValidation-makeSureYouRecieve');
    if (type === ACCESS_DATA) return formatText('accessDataSection-serveToAccess');

    return null;
};
